/**
 * Copyright © Veeam Software Group GmbH.
 */

export const getAdminDocUrl = (): string => RCOP.utils.HelpCenter.getHelpResource(642);
